import React, { Dispatch, SetStateAction} from 'react';

const AdvanceMenuContext = React.createContext({
    showMenu: false,
    setShowMenu: (show: boolean) => {}
});

export default AdvanceMenuContext;
